import $x from '@/utils/$x';

/**
+ * 学院添加
+ * @param {*} params
+ * @returns
+ */
export async function addTrainingCollege(params) {
  return $x.post('/train/add', params);
}
/**
+ * 学院更新
+ * @param {*} params
+ * @returns
+ */
export async function updateTrainingCollege(params) {
  return $x.post('/train/update', params);
}
/**
+ * 学院列表
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeList(params) {
  return $x.post('/train/list', params);
}
/**
+ * 学院详情
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeDetail(params) {
  return $x.post('/train/detail', params);
}
/**
+ * 学院删除
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeDelete(params) {
  return $x.post('/train/del', params);
}
/**
+ * 添加专栏
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeColumnAdd(params) {
  return $x.post('/train/column/add', params);
}
/**
+ * 专栏列表
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeColumnList(params) {
  return $x.post('/train/column/list', params);
}
/**
+ * 更新专栏
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeColumnUpdate(params) {
  return $x.post('/train/column/update', params);
}
/**
+ * 删除专栏
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeColumnDelete(params) {
  return $x.post('/train/column/del', params);
}

/**
+ * 添加课程
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeCourseAdd(params) {
  return $x.post('/train/course/add', params);
}
/**
+ * 课程列表
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeCourseList(params) {
  return $x.post('/train/course/list', params);
}
/**
+ * 更新课程
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeCourseUpdate(params) {
  return $x.post('/train/course/update', params);
}
/**
+ * 删除课程
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeCourseDelete(params) {
  return $x.post('/train/course/del', params);
}
/**
+ * 专栏学习进度
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeStudyList(params) {
  return $x.post('/train/study/list', params);
}
/**
+ * 课程专栏配置--播放限制枚举 ID：58p0gbE8
+ * @param {*} params
+ * @returns
+ */
export async function trainingCollegeAllowList(params) {
  return $x.post('/train/column/allow', params);
}

/**
+ * 销售助手Agent
+ * @param {*} params
+ * @returns
+ */
export async function salesAssistantAgent(params) {
  return $x.post('/v1/ai/agent/salesAssistant', params);
}
